import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Check change on this element
        this.el.addEventListener('change', () => {
            //Get the value of the selected option
            let season = this.el.value;
            //Update the season in the URL
            window.location
                .href = season
        });
    }
}
